<template>
  <div
    class="w-100 d-flex flex-column justify-content-center align-items-center"
  >
    <!--
    未来换新的首页的时候，删掉：
    <HomeContentOld v-if="pageContent === 'home'"></HomeContentOld>
    下面的div改为：
    <div class="content page-content">
    同时记得删掉对HomeContentOld的引用，即import和components里对应的两行
    -->
    <HomeContentOld v-if="pageContent === 'home'"></HomeContentOld>
    <div class="content page-content" v-if="pageContent !== 'home'">
      <!-- 未来换新首页的时候，把下面的pageContent === 'home-new'改为pageContent === 'home' -->
      <HomeContent v-if="pageContent === 'home-new'"></HomeContent>
      <AboutContent v-else-if="pageContent === 'en:pages/about'" />
      <AboutContentCN v-else-if="pageContent === 'cn:pages/about'" />

      <TrafficContent v-else-if="pageContent === 'en:pages/traffic-mining'" />
      <TrafficContentCN v-else-if="pageContent === 'cn:pages/traffic-mining'" />

      <GSGnGEMAContent v-else-if="pageContent === 'en:pages/gsg-gema'" />
      <GSGnGEMAContentCN v-else-if="pageContent === 'cn:pages/gsg-gema'" />

      <GSGNFTContent v-else-if="pageContent === 'en:pages/nft-gsg'" />
      <GSGNFTContentCN v-else-if="pageContent === 'cn:pages/nft-gsg'" />

      <NFTContent
        :nftType="pageContent.split('-').pop()"
        v-else-if="pageContent.includes('pages/nft-all-')"
      />

      <GEMANFTContent v-else-if="pageContent === 'en:pages/nft-gema'" />
      <GEMANFTContentCN v-else-if="pageContent === 'cn:pages/nft-gema'" />

      <TeamContent
        v-else-if="
          pageContent === 'en:pages/team' || pageContent === 'cn:pages/team'
        "
      />
      <ContactContent
        v-else-if="
          pageContent === 'en:pages/contact' ||
          pageContent === 'cn:pages/contact'
        "
      />

      <InvestorContent v-else-if="pageContent === 'en:pages/investor'" />
      <InvestorContentCN v-else-if="pageContent === 'cn:pages/investor'" />

      <BetaContent v-else-if="pageContent === 'en:pages/beta'" />
      <BetaContentCN v-else-if="pageContent === 'cn:pages/beta'" />

      <CareerContent v-else-if="pageContent === 'en:pages/careers'" />
      <CareerContentCN v-else-if="pageContent === 'cn:pages/careers'" />

      <CareerApplyContent
        v-else-if="
          pageContent === 'en:pages/careers-writer' ||
          pageContent === 'en:pages/careers-specialist' ||
          pageContent === 'en:pages/careers-developer' ||
          pageContent === 'cn:pages/careers-writer' ||
          pageContent === 'cn:pages/careers-specialist' ||
          pageContent === 'cn:pages/careers-developer'
        "
      />

      <TermsContent v-else-if="pageContent === 'en:pages/terms'" />
      <TermsContentCN v-else-if="pageContent === 'cn:pages/terms'" />

      <PrivacyContent v-else-if="pageContent === 'en:pages/privacy'" />
      <PrivacyContentCN v-else-if="pageContent === 'cn:pages/privacy'" />

      <div v-else class="not-find one-column-view">
        <div class="article-content">
          <h1>{{ $t("404", { page: pageContent }) }}</h1>
          <img src="../assets/404Error.jpg" alt="404" class="w-100 m-0" />
        </div>
      </div>
    </div>
    <LastestNFT
      v-if="
        pageContent === 'en:pages/nft-gsg' ||
        pageContent === 'cn:pages/nft-gsg' ||
        pageContent === 'en:pages/nft-gema' ||
        pageContent === 'cn:pages/nft-gema'
      "
      :pageType="pageContent.split('-').pop()"
    />
  </div>
</template>

<script>
import HomeContent from "@/pages/HomeContent.vue";
import AboutContent from "@/pages/AboutContent.vue";
import AboutContentCN from "@/pages/cn/AboutContentCN.vue";
import TrafficContent from "@/pages/TrafficContent.vue";
import TrafficContentCN from "@/pages/cn/TrafficContentCN.vue";
import GSGnGEMAContent from "@/pages/GSGnGEMAContent.vue";
import GSGnGEMAContentCN from "@/pages/cn/GSGnGEMAContentCN.vue";
import GSGNFTContent from "@/pages/GSGNFTContent.vue";
import GSGNFTContentCN from "@/pages/cn/GSGNFTContentCN.vue";
import NFTContent from "@/pages/NFTContent.vue";
import LastestNFT from "./LastestNFT.vue";
import TeamContent from "@/pages/TeamContent.vue";
import ContactContent from "@/pages/ContactContent.vue";
import InvestorContent from "@/pages/InvestorContent.vue";
import InvestorContentCN from "@/pages/cn/InvestorContentCN.vue";
import BetaContent from "@/pages/BetaContent.vue";
import BetaContentCN from "@/pages/cn/BetaContentCN.vue";
import CareerContent from "@/pages/CareerContent.vue";
import CareerApplyContent from "@/pages/CareerApplyContent.vue";
import CareerContentCN from "@/pages/cn/CareerContentCN.vue";
import TermsContent from "@/pages/TermsContent.vue";
import TermsContentCN from "@/pages/cn/TermsContentCN.vue";
import PrivacyContent from "@/pages/PrivacyContent.vue";
import PrivacyContentCN from "@/pages/cn/PrivacyContentCN.vue";
import GEMANFTContent from "@/pages/GEMANFTContent.vue";
import GEMANFTContentCN from "@/pages/cn/GEMANFTContentCN.vue";
// 未来换新的首页的时候，删掉HomeContentOld的引入
import HomeContentOld from "@/pages/HomeContentOld.vue";

export default {
  name: "MainPageViewer",
  components: {
    // 未来换新的首页的时候，删掉HomeContentOld这一行
    HomeContentOld,
    HomeContent,
    AboutContent,
    AboutContentCN,
    TrafficContent,
    TrafficContentCN,
    GSGnGEMAContent,
    GSGnGEMAContentCN,
    GSGNFTContent,
    GSGNFTContentCN,
    GEMANFTContent,
    GEMANFTContentCN,
    NFTContent,
    LastestNFT,
    TeamContent,
    ContactContent,
    InvestorContent,
    InvestorContentCN,
    BetaContent,
    BetaContentCN,
    CareerContent,
    CareerContentCN,
    CareerApplyContent,
    TermsContent,
    TermsContentCN,
    PrivacyContent,
    PrivacyContentCN,
  },
  data() {
    return {
      pageContent: "",
    };
  },
  mounted() {
    this.getCurrentPage();
  },
  methods: {
    getCurrentPage() {
      console.log(this.$i18n.locale);
      const currentPath = this.$router.history.current.path.substring(1);
      console.log(currentPath);
      switch (currentPath) {
        case "":
        case "/":
        case undefined:
          this.pageContent = "home";
          break;

        default:
          this.pageContent = this.$i18n.locale + ":" + currentPath;
          break;
      }
    },
  },
  watch: {
    $route(to) {
      const currentPath = this.$router.history.current.path.substring(1);
      switch (currentPath) {
        case "":
        case "/":
        case undefined:
          this.pageContent = "home";
          break;

        default:
          this.pageContent = this.$i18n.locale + ":pages/" + to.params.page;
          break;
      }
      window.scrollTo(0, 0);
    },
    "$i18n.locale": function () {
      this.getCurrentPage();
    },
  },
};
</script>

<style scoped>
.page-content {
  background-color: white;
  color: #3b3e51;
  box-shadow: 0px 4px 20px 0px #0000000d;
  border-radius: 0;
}

/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .page-content {
    border-radius: 1rem;
    margin-bottom: 2rem;
  }
}
</style>
